import { useIsMobile } from "./useMediaQuery";

/**
 * Hook for mobile-optimized motion settings
 * Reduces animation overhead on mobile devices
 */
export const useMobileOptimizedMotion = () => {
  const isMobile = useIsMobile();
  
  return {
    // Fast duration on all devices
    duration: 0.15,
    
    // Disable hover effects on touch devices
    enableHover: !isMobile,
    
    // Fast delays for all devices
    reduceDelay: (delay: number) => delay * 0.3,
    
    // Optimized viewport settings
    viewport: {
      once: true,
      margin: "50px"
    }
  };
};
